export const DEFAULT_COLOR = 'default';
export const DIAP_COLOR = 'diap';
export const DEFAULT_SIZE = 50;
